import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CloseEyes, OpenEyes } from "./StudentSignin";
import Button from "../../../../components/Button";
import { useLoginTutorMutation } from "../../../../hooks/api/Tutors/Auth/useLoginTutorMutation";

type Props = {};

const TutorSignInFlow = (props: Props) => {
  const navigate = useNavigate();
  const [payload, setPayload] = useState({ email: "", password: "" });

  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const { mutateAsync: signin, isLoading } = useLoginTutorMutation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  const isFormValid =
    payload.email.trim() !== "" && payload.password.trim() !== "";

  const handleSubmit = async () => {
    try {
      await signin(payload);
      navigate("/tutor/overview");
    } catch (error) {
      console.error("Sign-in failed:", error);
    }
  };

  return (
    <div>
      <div className="w-full mb-5">
        <label htmlFor="email" className="text-gray700">
          Email
        </label>
        <input
          name="email"
          type="email"
          placeholder="Enter your email"
          className="border-[1px] rounded-md border-gray300 p-4 block mt-3 outline-none w-full"
          value={payload?.email}
          //   disabled={isLoading}
          onChange={handleChange}
        />
      </div>
      <div className="w-full">
        <label htmlFor="password" className="text-gray700">
          Password
        </label>
        <div className="relative">
          <input
            name="password"
            type={passwordVisibility === true ? "text" : "password"}
            placeholder="Enter your password"
            className="border-[1px] rounded-md border-gray300 p-4 block mt-3 outline-none w-full"
            value={payload?.password}
            // disabled={isLoading}
            onChange={handleChange}
          />
          <span
            className="absolute right-6 top-[17px] flex text-gray400 items-center text-sm"
            onClick={() => setPasswordVisibility(!passwordVisibility)}
          >
            {passwordVisibility ? <OpenEyes /> : <CloseEyes />}
          </span>
        </div>
      </div>
      <div className="text-right mt-2">
        <Link to="/tutor/reset" className="text-gray500">
          <span className="text-primary700 W2STMedium">Forgot Password?</span>
        </Link>
      </div>
      <Button
        label="Sign In"
        isFormValid={isFormValid}
        isLoading={isLoading}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default TutorSignInFlow;
